import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

// Din publika Firebase-konfiguration. Byt ut värdena nedan
// mot de som finns i din Firebase Console -> "Project Settings" -> "General" -> "Your apps".
const firebaseConfig = {
  apiKey: "AIzaSyDKjvBOnOFxdZ_9vdQrKQp2Jvca3ThhQlo",
  authDomain: "dagens-l-tt.firebaseapp.com",
  projectId: "dagens-l-tt",
  storageBucket: "dagens-l-tt.firebasestorage.app",
  messagingSenderId: "38801226922",
  appId: "1:38801226922:web:59426733a0d6cc471b24d3"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

export { auth };
